export const shouldLoad = () => document.querySelector('.card-block') !== undefined;